<button [id]="identifier"
        [type]="customType"
        [disabled]="disabled || loading"
        [ngClass]="['btn btn-mahikari', customClass, iconRight? 'reverse-icon':'']">
  <i *ngIf="!loading" [class]="iconClass"></i>
  <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
  <span>{{ label }}</span>
</button>
